module.exports = __webpack_public_path__ + "img/zhang.6447569d.png";